<div class="map-container">
  <div *ngIf="!!totalDistance" class="distance-legend">
    Totale afstand: <b>{{ totalDistance }}</b>
  </div>
  <map-view
    [latitude]="INPRESS_COORDINATES.lat"
    [longitude]="INPRESS_COORDINATES.lng"
    [zoom]="14"
    [maxZoom]="19"
    [scrollwheel]="true"
    [fitBounds]="markers?.length > 0"
    [styles]="HIDE_POI_STYLE"
    [disableDefaultUI]="true"
  >
    <map-marker
      [latitude]="INPRESS_COORDINATES.lat"
      [longitude]="INPRESS_COORDINATES.lng"
      [iconUrl]="'../../../../../../../favicon.ico'"
    ></map-marker>
    <map-marker
      *ngFor="let marker of markers"
      [latitude]="marker.lat"
      [longitude]="marker.lng"
      [label]="{
        text: marker.index,
        color: 'white',
        fontWeight: 'bold'
      }"
      [iconUrl]="{
        url: '../../../../../../../assets/full-markers/' + marker.markerColor,
        labelOrigin: marker.labelOrigin
      }"
      [mapFitBounds]="true"
      (markerClick)="markerClick(infoWindow, group)"
    >
    </map-marker>
  </map-view>
</div>
